import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(({  variables, palette, breakpoints }) => ({
  managerPromotionContent:{
    width:'900px',
    [breakpoints.down('sm')]: {
      width:'680px',
    }, 
    [breakpoints.down('xs')]: {
      width:'100%',
      flexDirection: 'column',
      paddingLeft:variables?.spacingE,
      paddingRight:variables?.spacingE,
      height:'auto'
    },
    height:'328px',
    margin:'0 auto',
    display:'flex',
    '& .title-icon': {
      color: palette.jet?.supportBrand01,
      fontWeight:'bold !important',
      marginRight: `${variables?.spacingB}`,
    },
    '& .managerpromotioncontent-title':{
      marginBottom:variables?.spacingE
    },
    '& .managerpromotioncontent-description':{
      marginBottom:variables?.spacingD
    },
    '& .managerpromotion-side-section-1': {
      width:'712px',
      paddingRight:variables?.spacingC,
      [breakpoints.down('sm')]: {
        width:'500px',
      },
      [breakpoints.down('xs')]: {
        width:'100%'
      }, 
      '& .title-holder': {
        display:'flex', 
        alignItems:'center'
      },
      '& .phone-image-mobile-view':{ 
        margin:'0 auto',
        display:'block',
        marginBottom:variables?.spacingB,
        height:'328px'
      },
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    },
    '& .managerpromotion-side-section-2': {
        '& .retina-image':{
          display:'none'
        },
        ['@media  only screen and (min-device-pixel-ratio: 2),only screen and (min-resolution: 192dpi)']:{
          '& .retina-image':{ 
            height:'328px',
            display:'block'
          },
          '& .original-image':{
            display:'none'
          }
        },
        [breakpoints.down('xs')]: {
          display:'flex',
          justifyContent:'center'
        }
    }
  },
}));

export default useStyles;
